import { render } from "./case_list.vue?vue&type=template&id=cd0e6980"
import script from "./case_list.vue?vue&type=script&lang=js"
export * from "./case_list.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__